
import React, { Fragment, useEffect, useRef } from "react";
export default function PreviewVoucherList({ gid, pid, iid, vid, hanldeLoading, propertyData, data, close_clicked, locale }) {    
    const currencyFormat = (currency, value) =>
        new Intl.NumberFormat(locale, {
            style: 'currency',
            currency: currency
        }).format(value);

    let script =`  <script>`;
    if(iid !==undefined)
      script +=`
      var aiva_Voucher_domain = '${process.env.REACT_APP_VOUCHER_URL}/';
      var aiva_Voucher_botHTMLPath = aiva_Voucher_domain;
      var aiva_Voucher_head = document.getElementsByTagName('head')[0];
      var aiva_Voucher_script = document.createElement('script');
      aiva_Voucher_script.type = 'text/javascript';
      aiva_Voucher_script.src = aiva_Voucher_domain + 'embedVoucherPlugin.js';
      aiva_Voucher_head.appendChild(aiva_Voucher_script);
      var aiva_Voucher_gid = '${gid}';
      var aiva_Voucher_iid = '${iid}';
      var aiva_Voucher_pid = '';
      var aiva_Dashboard =true;
      </script>  `;    
     //voucherwindowClose   
    const InjectScript = (({ script }) => {
        const divRef = useRef(null);
    
        useEffect(() => {
          if (divRef.current === null) {
            return;
          }          
          // create a contextual fragment that will execute the script
          // beware of security concerns!!
          const doc = document
              .createRange()
              .createContextualFragment(script);
          
          // clear the div HTML, and append the doc fragment with the script 
          divRef.current.innerHTML = '';
          divRef.current.id = "testScriptName";
          divRef.current.appendChild(doc);
          
        })
    
        return <div ref={divRef} />
      });      
    return (
      <Fragment>
        <InjectScript script={script}></InjectScript> 
{/* {vid !== undefined &&
        <iframe frameborder='0'
          className='bmb_voucher_frame_default'
          style={{ position: 'fixed', bottom: 0, right: 0, margin: 0, zIndex: '9999998' }}
          id={'voucheriframe'}
          src= {`http://localhost:4500/voucherengine?location=file%3A%2F%2F%2FC%3A%2FUsers%2Fbmb_dev_vm%2FPictures%2Faiva-vouchers-view%2Findex.html&title=&referrer=&iid=4405ff2e-82e0-427a-bd6a-01309d4a3dc9&gid=73574010-2f33-4b41-8b8a-09d18b025a56&pid=e655dab2-987b-4683-ad9b-599814b414b6&mobile=false&position=right&preview=false&dashboard=true&vid=${vid}`}></iframe>} */}
      </Fragment>
    );

}